import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RootApp from './RootApp';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import { store } from './app/store';
// Import the RootApp component which is the main application component
// This component will be rendered into the root element of the HTML document
const root = ReactDOM.createRoot(document.getElementById('root'));
// Render the RootApp component inside a StrictMode wrapper for better development practices
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <RootApp />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
